// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lw-0";
export var assigneeDetails = "_lw-1";
export var assigneeInfo = "_lw-2";
export var dropdownContainer = "_lw-4";
export var dropdownImage = "_lw-5";
export var editAssigneeInfo = "_lw-3";
export var editAssigneeModalContainer = "_lw-6";
export var hidden = "_lw-8";
export var input = "_lw-7";